import { Component } from "react";

export default class ContactListComponent extends Component{
    render = () =>{
        return <h1>Đây là màn hình danh sách Liên hệ</h1>
    }
}